/**
 * @description Статус виджета "Включён".
 * @type {string}
 */
const WIDGET_STATUS_ENABLE = 'enable';

/**
 * @description Примись "Виджет HD".
 * @type {object}
 */
export default {
  methods: {
    /**
     * @description Добавить "Виджет HD"
     * @return {void}
     */
    appendWidgetScript() {
      if (!process.env.VUE_APP_WIDGET_HD === WIDGET_STATUS_ENABLE) {
        return;
      }
      const script = document.createElement('script');
      script.setAttribute(
        'src',
        '//cdn5.helpdeskeddy.com//js/contact-widget.js',
      );
      script.setAttribute(
        'id',
        'hde-contact-widget',
      );
      script.setAttribute(
        'data-assets-host',
        '//cdn5.helpdeskeddy.com/',
      );
      script.setAttribute(
        'data-host',
        'mis32.helpdeskeddy.com',
      );
      script.setAttribute(
        'data-lang',
        'ru',
      );
      script.setAttribute(
        'defer',
        'defer',
      );
      script.setAttribute(
        'data-comment',
        this.$store.getters.getUserBasicData,
      );
      document.body.appendChild(script);
    },
  },
};
